"use client";

// Deprecated combined navigation file. Header & Footer moved to dedicated components.
// This file now only exports the navigation items array for reuse.

const navigation = [
  { name: "Courses", href: "/courses" },
  { name: "Blog", href: "/blog" },
  { name: "Pricing", href: "/pricing" },
  { name: "Advertise", href: "/advertise" },
  { name: "Contact", href: "/contact" },
  { name: "Contractor Directory", href: "/applicators" },
];

export { navigation };
